import "./medication-alerts-preview.scss";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";
import { SignalrEvent } from "../../../signalr/hubs-container";
import { AccountEvent } from "../../../services/auth-service";
import { IMessageItem } from "../../../interfaces/i-message";
import { EnumsService } from "../../../services/enums-service";
import { EnumMap } from "../../../common/utilities/enum-map";
import { MessageService } from "../../../services/message-service";
import { MessageListEvent } from "../../../pages/message-center/conversation/messages-renderer";

@autoinject
export class MedicationAlertsPreview {
    private _messageService: MessageService;
    private _enumsService: EnumsService;
    private _ea: EventAggregator;
    private pageNumber: number = 1;
    private pageLength: number = 5;
    private _eaSubscriptions: Subscription[] = [];
    public medicationAlerts: IMessageItem[] = [];
    public shakeMessageIcon: boolean = false;
    public isLoading: boolean = true;
    public medAlertConversationId: string = "";
    public conversationTypeEnumMap: EnumMap = new EnumMap([]);
    public medicationAlertsTotal: number = null;

    public constructor(enumsService: EnumsService, ea: EventAggregator, messageService: MessageService) {
        this._enumsService = enumsService;
        this._ea = ea;
        this._messageService = messageService;
    }

    public async attached() {
        let conversationTypeEnum = await this._enumsService.getConversationType();
        this.conversationTypeEnumMap = new EnumMap(conversationTypeEnum);
        await this.getUnreadConversations();
        this.initSubscriptions();
    }

    public initSubscriptions() {
        this._eaSubscriptions.push(
            this._ea.subscribe(AccountEvent.Selected, async () => {
                await this.getUnreadConversations();
            })
        );
        this._eaSubscriptions.push(
            this._ea.subscribe(SignalrEvent.NewMessage, async () => {
                await this.getUnreadConversations();
            })
        );
        this._eaSubscriptions.push(
            this._ea.subscribe(MessageListEvent.HasUnreadMessage, async () => {
                await this.getUnreadConversations();
            })
        );
    }

    public async getUnreadConversations() {
        try {
            this.isLoading = true;
            let result = await this._messageService.getUnreadConversations({
                page: this.pageNumber,
                pageLength: this.pageLength,
                conversationType: Number(this.conversationTypeEnumMap.getEnumValue("Medication Alert"))
            });
            let conversations = result.items ? result.items : [];
            if (!conversations.length) {
                this.medicationAlerts = [];
                return;
            }
            this.medAlertConversationId = conversations[0]?.id;
            this.medicationAlerts = await this._messageService.getUnReadMessages(this.medAlertConversationId, true);
            if (this.medAlertConversationId) {
                this.shakeMessageIcon = true;
            }
            this.medicationAlertsTotal = this.medicationAlerts?.length;
            if (this.medicationAlerts?.length > 5) {
                this.medicationAlerts = this.medicationAlerts.splice(0, 5);
            }
        } catch (e) {
            console.error(e);
            this.isLoading = false;
        }
        setTimeout(() => (this.shakeMessageIcon = false), 1000);
    }

    public detached() {
        if (this._eaSubscriptions.length > 0) {
            this._eaSubscriptions.forEach((sub) => sub.dispose());
        }
    }
}
